import styled, { css } from 'styled-components'
import { COLORS } from '@styles/colors'
import { FONTS, textSM } from '@styles/fonts'
import { DEVICES } from '@constants/global'

export const MobileLabel = styled.span`
  display: none;
`

export const ListingCardInspection = styled.div`
  color: ${COLORS.navi};

  label {
    ${textSM};
    font-family: ${FONTS.bold};
    letter-spacing: 1px;
    color: ${COLORS.primary};
    text-transform: uppercase;
    margin-bottom: 4px;
    display: block;
  }

  @media ${DEVICES.mobile} {
    label {
      span {
        display: none;
      }
      ${MobileLabel} {
        display: block;
      }
    }

    ${({ primary }) =>
      primary &&
      css`
        color: ${COLORS.secondary};
      `}
  }
`
